<script lang="ts">
    import type { TileImage } from '@shared/types/types';
    import ProductImage from '@tile/components/product-image/ProductImage.svelte';
    import type { ImageAspectRatio, ImageLoadingOptions } from '@tile/components/product-image/types.ts';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import ProductImageE3933 from '@tilelist/layouts/experiments/e3933/product-image/ProductImage.svelte';

    interface Props {
        fallbackImage: TileImage;
        variationId: string;
        detailPageLink: string;
        imageLoadingOptions: ImageLoadingOptions;
        onClick?: (event: Event) => void;
        aspectRatio?: ImageAspectRatio;
    }

    let { fallbackImage, variationId, imageLoadingOptions, aspectRatio }: Props = $props();

    const onex = injectWiring().onex;
    const visualRefreshActive = $derived(onex.isExperimentGroup('VISUAL_REFRESH', 'E3933B'));
</script>

{#if visualRefreshActive}
    <ProductImageE3933 image={fallbackImage} {variationId} {imageLoadingOptions} {aspectRatio} />
{:else}
    <ProductImage image={fallbackImage} {variationId} {imageLoadingOptions} {aspectRatio} />
{/if}
